import { ActionTypes } from "../constants";

export const finishedTasks = () => ({ type: ActionTypes.TASKS_FINISHED });

export const runTasks = () => ({ type: ActionTypes.TASKS_RUN });

export default {};